import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

export type ListView = "table" | "cards";

const STORAGE_PREFIX = "cortex.view.";

export function loadView(key: string, fallback: ListView = "table"): ListView {
  try {
    const v = localStorage.getItem(STORAGE_PREFIX + key);
    return v === "cards" || v === "table" ? v : fallback;
  } catch {
    return fallback;
  }
}

export function saveView(key: string, value: ListView): void {
  try {
    localStorage.setItem(STORAGE_PREFIX + key, value);
  } catch {
    /* quota or disabled */
  }
}

export function ViewToggle({
  view,
  onChange,
}: {
  view: ListView;
  onChange: (v: ListView) => void;
}) {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={view}
      onChange={(_, v) => {
        if (v) onChange(v);
      }}
      aria-label={t("view.toggleLabel")}
    >
      <Tooltip title={t("view.table")}>
        <ToggleButton value="table" aria-label={t("view.table")}>
          <ViewListIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
      <Tooltip title={t("view.cards")}>
        <ToggleButton value="cards" aria-label={t("view.cards")}>
          <GridViewIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
}
